import React, { useEffect, useState } from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { useAppSelector } from "../../../../../redux";

interface PointsAcceleratorsSectionProps {
  isEditable: boolean; // kept for compatibility, not used in partner view
  selectedAssesmentData: any;
}

const PointsAcceleratorsSection: React.FC<PointsAcceleratorsSectionProps> = ({
  selectedAssesmentData,
}) => {
  const [extraPoints, setExtraPoints] = useState(0);
  const regionalModifier = selectedAssesmentData.regional_modifier || 1;
  const totalMultiplier = selectedAssesmentData.total_multiplier || 0;

  const { partnerLicenceList } = useAppSelector(
    (state) => state.partner_licenceProgram
  );

  useEffect(() => {
    const totalLic = selectedAssesmentData.partner_total_licenses;
    if (!partnerLicenceList || !partnerLicenceList.length || !totalLic) {
      setExtraPoints(0);
      return;
    }

    const sorted = [...partnerLicenceList].sort(
      (a, b) => a.license_count - b.license_count
    );

    let points = 0;
    for (let i = sorted.length - 1; i >= 0; i--) {
      if (totalLic >= sorted[i].license_count) {
        points = sorted[i].points;
        break;
      }
    }
    setExtraPoints(points);
  }, [partnerLicenceList, selectedAssesmentData.partner_total_licenses]);

  const rows = [
    {
      label: "Points to next Tier",
      value: (selectedAssesmentData.points_to_next_tier || 0).toLocaleString(),
      colorClass: "purple-light",
      icon: "circleCheck",
    },
    {
      label: "licenses to next Tier",
      value: (selectedAssesmentData.licenses_to_next_tier || 0).toLocaleString(),
      colorClass: "green-light",
      icon: "award",
    },
    {
      label: "Potential Points",
      value: (selectedAssesmentData.potential_improvement || 0).toLocaleString(),
      colorClass: "orange-light",
      icon: "arrowTrendUp",
    },
  ];

  return (
    <div className="detail-section">
      <h2>Next Tier In</h2>
      <div className="summary-grid">
        {rows.map((row, index) => (
          <div key={index} className={`summary-card ${row.colorClass}`}>
            <div className="card-content">
              <div className="card-left">
                <span className="card-icon-wrapper">
                  <Iconography
                    icon={row.icon as any}
                    size={IconographySizes.Small}
                  />
                </span>
                <span className="card-label">{row.label}</span>
              </div>
              <span className="card-value">{row.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PointsAcceleratorsSection;
